<template>
  <div>
    <hshead title="帮助与反馈" bgcolor="#fff"></hshead>
    <div class="product-ul" style="height: 100%;">
      <div class="help-kefu" @click="serviceHelp()">
        <img src="~@/assets/images/center/kefu-service.png" class="help-kefu-img" />
        <span class="help-kefu-span1">官方管家客服</span>
        <span class="help-kefu-span2">有问题? 联系客服服务您</span>
      </div>
      <div class="help-kefu" @click="feedback()" style="margin-top: 0.3rem;">
        <img src="~@/assets/images/center/opinion.png" class="help-feedback-img" />
        <span class="help-feedback-span1">意见反馈</span>
        <span class="help-feedback-span2">您的关注是我们成长的动力</span>
      </div>
    </div>

    <!-- 管家客服 -->
    <div v-if="dialogVisible">
      <div class="el-dialog__wrapper" style="z-index: 10;">
        <div
          role="dialog"
          aria-modal="true"
          aria-label="官方管家客服"
          class="el-dialog"
          style="width: 100%;"
        >
          <!-- 头部信息 -->
          <div class="el-dialog__header">
            <span class="el-dialog__title">
              <div style="text-align: center;margin-top: 0.25rem;">官方管家客服</div>
            </span>
            <span>
              <i
                style="font-size: 0.5rem;margin-top: 0.1rem;"
                class="van-icon van-icon-close"
                @click="dialogVisible=false"
              ></i>
            </span>
          </div>

          <!-- 内容板块 -->
          <div class="el-dialog__body">
            <div style="height: 667px;">
              <div id="service">
                <div id="serviceContent" class="service-content" style="height: 73%;">
                  <div class="service-content-out" id="messageContent">
                    <div class="kefu-qa">
                      <div class="kefu-qa-guess">
                        <span class="kefu-qa-guess-span1">店铺运营指南</span>
                        <span class="kefu-qa-guess-span2">有问题，找小拍</span>
                        <div class="kefu-qa-more" @click="moreQA()">更多</div>
                      </div>
                      <div class="kefu-qa-issue">
                        <ul class="kefu-qa-ul">
                          <li
                            v-for="(item,index) in QAServiceData"
                            :key="item.id"
                            @click="matchingIS(item.id)"
                          >
                            {{(index+1)+"."+item.questions}}
                            <van-icon name="arrow" style="float: right;" />
                          </li>
                          <!-- <li>2.添加产品案例流程</li>
                          <li>3.产品上架流程</li>
                          <li>4.产品上架流程</li>-->
                        </ul>
                      </div>
                    </div>

                    <!-- 对话消息 -->
                    <div>
                      <div class="service-time">官方管家智能客服服务中心</div>
                      <div class="left-content">
                        <div class="this-icon">
                          <img src="~@/assets/images/center/bannerLogo.jpg" />
                        </div>
                        <div class="left-content-p">亲爱哒，我是【管家客服】小拍，您可以点击上方问题，或者输入关键字向我提问哦。~</div>
                        <div class="clear"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="service-save">
                  <div class="save-textarea">
                    <textarea maxlength="200" name id="smsTextarea" placeholder="您可以输入关键字向我提问"></textarea>
                  </div>
                  <div class="right-btn" @click="sendMessage()">发送</div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 意见反馈 -->
    <div v-if="dialogFeedback">
      <div class="el-dialog__wrapper" style="z-index: 10;">
        <div
          role="dialog"
          aria-modal="true"
          aria-label="意见反馈"
          class="el-dialog"
          style="width: 100%;"
        >
          <!-- 头部信息 -->
          <div class="el-dialog__header">
            <span class="el-dialog__title">
              <div style="text-align: center;margin-top: 0.15rem;">意见反馈</div>
            </span>
            <span>
              <i
                style="font-size: 0.5rem;left: 0.2rem;width: 0.5rem;"
                class="van-icon van-icon-close"
                @click="dialogFeedback=false"
              ></i>
            </span>
            <span
              @click="onSubmitFeedback()"
              style="font-size: 0.25rem;position: absolute;top: 0.35rem;left: 6.8rem;color: #888;"
            >提交</span>
          </div>
          <!-- 内容板块 -->
          <div class="el-dialog__body">
            <div style="background: #ececec;position: relative;top: 0.9rem;">
              <div style="width: 100%;background-color: rgb(255, 215, 215);height: 0.8rem;">
                <span
                  style="position: relative;top: 0.3rem;color: #ff4d4d;;left: 0.5rem;font-size: 0.24rem;"
                >如您在操作过程中出现问题请上传相关截图</span>
              </div>
              <div>
                <textarea
                  placeholder="反馈内容"
                  style="width: 7.41rem;border: 0px;height: 3rem;resize: none;"
                  maxlength="500"
                  rows="3"
                  cols="20"
                  id="feedbackContent"
                ></textarea>
              </div>
              <div style="margin-bottom: 0.11rem;background-color: #fff;margin-top: -0.1rem;font-size: 0.2rem;color: #9b9b9b;"> <span style="margin-left: 0.2rem;">图片最多5张</span></div>
              <div style="background-color: #fff;margin-top: -0.1rem;">
                <van-uploader
                  :max-count="5"
                  style="margin-left: 0.15rem;"
                  v-model="fileList"
                  multiple
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Toast,
  Image,
  Tabbar,
  TabbarItem,
  List,
  Icon,
  Dialog,
  Notify,
  Popup,
  Field,
  Uploader
} from "vant";
import tempImg from "@/assets/images/product/tempBus.jpg";
import { getStoreDetail } from "@/api/m/store";
import {
  getQAService,
  submitFeedback,
  getUser,
  getOssAutograph
} from "@/api/m/user";
import { diffTimeSecond, parseTime } from "@/utils";
import $ from "jquery";
import Vue from "vue";

Vue.use(Notify, Popup, Field);
Vue.use(Uploader);
export default {
  name: "helpFeedback",
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      dialogVisible: false,
      QAparparameterm: {
        pn: 1,
        ps: 5
      },
      QAServiceData: [],
      QAServiceDataAll: [],
      maxQANumber: 2,
      userAvatar: "",
      dialogFeedback: false,
      fileList: [
        // { url: "https://img.yzcdn.cn/vant/leaf.jpg" },
        // // Uploader 根据文件后缀来判断是否为图片文件
        // // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        // { url: "https://cloud-image", isImage: true }
      ],
      ossAjax: "http://lshoot-images.oss-cn-shenzhen.aliyuncs.com",
      catalogue: "Test/",
      fileData: {
        name: "${filename}",
        key: "",
        policy: "",
        OSSAccessKeyId: "",
        success_action_status: 200,
        signature: ""
      },
      imagesFeedback: [],
      preparationQAData: []
    };
  },
  methods: {
    //客服
    serviceHelp() {
      this.dialogVisible = true;
    },
    //反馈
    feedback() {
      this.dialogFeedback = true;
    },
    //发送消息
    //content: "";position: absolute;width: 0;height: 0;right: -0.28rem;top: 0.2rem;border-width: 0.15rem;border-style: solid;border-color: transparent transparent transparent #94e96b;
    sendMessage() {
      var text = $("#smsTextarea").val();
      text = text.replace(/\s+/g, "");
      if (text) {
        var time = new Date().toLocaleString();
        var _html =
          '<div style="display:inline-block;">' +
          '<div style="width: 100%;font-size: 0.24rem;text-align: center;color: #ccc;margin-top: 0.3rem;" class="service-time">' +
          time +
          "</div>" +
          '<div style="width: 7.2rem;padding: 0 0.15rem;margin-top: 0.2rem;" class="right-content">' +
          '<div style="float: right;margin-right: 0.2rem;width: 0.8rem;height: 0.8rem;margin-left: 0.2rem;border-radius: 50%;overflow: hidden;background: #ccc;" class="this-icon">' +
          '<img src="' +
          this.userAvatar +
          '" class="user-avatar" style="height: 100%;width: 100%;vertical-align: top;"/>' +
          "</div>" +
          '<div style="float: right;margin-right: 0.3rem; width: auto;max-width: 4.8rem;margin-left: 0.3rem;padding: 0.2rem;border-radius: 0.1rem;background: #94e96b;font-size: 0.28rem;margin-top: 0.1rem;line-height: 1.4;position: relative;word-wrap: break-word;" class="right-content-p">' +
          text +
          "</div>" +
          '<div class="clear"></div>' +
          "</div>" +
          "</div>";
        $("#messageContent").append(_html);
        $("#smsTextarea").val("");
        var ele = document.getElementById("serviceContent");
        ele.scrollTop = ele.scrollHeight;

        if (this.isRealNum(text) && this.preparationQAData.length > 0) {
          if (Number(text) <= 0) {
            this.replyHtml("您输入的问题序号有误请重新输入", "");
            return true;
          }
          if (this.preparationQAData.length > Number(text) - 1) {
            this.replyMessage(
              this.preparationQAData[Number(text) - 1].questions,
              this.preparationQAData[Number(text) - 1].answers
            );
            return true;
          } else {
            this.replyMessage("请重新输入要查询的内容", "");
            return true;
          }
        }
        this.preparationQAData = [];
        if (!this.isRealNum(text)) {
          this.matchingIS(undefined, text);
        } else {
          this.replyMessage(
            "很抱歉，小拍没有理解您的意思，您还可以通过点击上方问题 或 输入关键字向我提问",
            ""
          );
        }

        // if (text.indexOf("人工") != -1) {
        //   this.replyMessage(
        //     "去拍拍服务热线：400-920-7052",
        //     "服务时间：工作日 9:00 - 18:00"
        //   );
        // } else {

        // }
      }
    },
    //检测是否数字
    isRealNum(val) {
      if (val === "" || val == null) {
        return false;
      }
      if (!isNaN(val)) {
        return true;
      } else {
        return false;
      }
    },
    //客服回复
    replyMessage(title, text) {
      var time = new Date().toLocaleString();
      var _html =
        '<div style="display:inline-block;">' +
        '<div style="width: 100%;font-size: 0.24rem;text-align: center;color: #ccc;margin-top: 0.3rem;" class="service-time">' +
        time +
        "</div>" +
        '<div style="width: 7.2rem;padding: 0 0.15rem;margin-top: 0.2rem;" class="left-content">' +
        '<div style="width: 0.8rem;height: 0.8rem;margin-left: 0.2rem;border-radius: 50%;overflow: hidden;float: left;background: #ccc;" class="this-icon">' +
        '<img style="width: 100%;vertical-align: top;" src="/static/img/bannerLogo.eaed21d.jpg" />' +
        "</div>" +
        '<div style="width: auto;max-width: 4.8rem;margin-left: 0.3rem;padding: 0.2rem;border-radius: 0.1rem;font-size: 0.28rem;margin-top: 0.1rem;line-height: 1.4;position: relative;word-wrap: break-word;float: left;margin-left: 0.3rem;background: #fff;" class="left-content-p"><div>' +
        title +
        "</div>" +
        text +
        "</div>" +
        '<div class="clear"></div>' +
        "</div>" +
        "</div>";
      $("#messageContent").append(_html);
      var ele = document.getElementById("serviceContent");
      ele.scrollTop = ele.scrollHeight;
    },
    //获取客服问题数据
    getQAHtml() {
      if (this.QAparparameterm.pn <= this.maxQANumber) {
        getQAService(this.QAparparameterm)
          .then(response => {
            const { code, data } = response;
            if (code >= 0) {
              if (data.res.list.length > 0) {
                for (let i = 0; i < data.res.list.length; i++) {
                  this.QAServiceData.push(data.res.list[i]);
                }
              }

              // this.QAServiceData = data.res.list;
              this.QAServiceDataAll = data.list;
              this.maxQANumber = Math.ceil(data.res.totalRecord / 5);
            }
          })
          .catch(response => {
            this.$message({
              message: response.msg,
              type: "error",
              duration: 1000 * 5
            });
          });
      } else {
        Notify({
          type: "warning",
          message: "暂无更多，您还可以通过回复查找问题"
        });
      }
    },
    //逻辑处理客服回复
    matchingIS(id, text) {
      if (id) {
        for (let i = 0; i < this.QAServiceDataAll.length; i++) {
          if (this.QAServiceDataAll[i].id == id) {
            this.replyMessage(
              this.QAServiceDataAll[i].questions,
              this.QAServiceDataAll[i].answers
            );
            return true;
          }
        }
      }
      if (text) {
        for (let i = 0; i < this.QAServiceDataAll.length; i++) {
          var isH = this.QAServiceDataAll[i].answers.indexOf(text);
          var isW = this.QAServiceDataAll[i].questions.indexOf(text);
          if (isH != -1 || isW != -1) {
            this.preparationQAData.push(this.QAServiceDataAll[i]);
          }

          if (
            this.QAServiceDataAll.length - 1 == i &&
            this.preparationQAData.length == 0
          ) {
            this.replyMessage(
              "很抱歉，小拍没有理解您的意思，您还可以通过点击上方问题 或 输入关键字向我提问",
              ""
            );
          }
          if (
            this.QAServiceDataAll.length - 1 == i &&
            this.preparationQAData.length > 1
          ) {
            var _htmlTitile = "<div>请根据下面问题序号咨询</div>";
            for (let i = 0; i < this.preparationQAData.length; i++) {
              _htmlTitile +=
                "<div>" +
                (i + 1) +
                "." +
                this.preparationQAData[i].questions +
                "</div>";
              if (this.preparationQAData.length - 1 == i) {
                this.replyMessage(_htmlTitile, "");
              }
            }
          }
          if (
            this.QAServiceDataAll.length - 1 == i &&
            this.preparationQAData.length == 1
          ) {
            this.replyMessage(
              this.preparationQAData[0].questions,
              this.preparationQAData[0].answers
            );
          }
        }
      }
    },
    //更多问题
    moreQA() {
      this.QAparparameterm.pn = this.QAparparameterm.pn + 1;
      this.getQAHtml();
    },
    //提交反馈数据
    onSubmitFeedback() {
      var content = $("#feedbackContent").val();
      if (content == "") {
        Notify({
          type: "warning",
          message: "请填写反馈内容"
        });
        return false;
      }
      this.load(true, "");
      this.submitUpload();
      this.onSubmit(content);
    },
    onSubmit() {
      var content = $("#feedbackContent").val();
      if (content == "") {
        Notify({
          type: "warning",
          message: "请填写反馈内容"
        });
        return false;
      }
      if (this.fileList.length != this.imagesFeedback.length) {
        setTimeout(() => {
          this.onSubmit();
        }, 1000);
        return false;
      } else {
        var imgStr = this.imagesFeedback.join(",");
        var query = { Content: content, imagesStr: imgStr };
        submitFeedback(query).then(response => {
          const { code, data } = response;
          if (code >= 0) {
            this.load(false, "");
            Notify({
              type: "success",
              message: "提交成功"
            });
            this.fileList = [];
            this.imagesFeedback = [];
            this.dialogFeedback = false;
          }
        });
      }
    },
    // formData图片上传
    submitUpload() {
      let that = this;
      if (that.fileData.OSSAccessKeyId == "") {
        this.getOssAutograph();
      }
      const { host, OSSAccessKeyId, policy, signature } = that.fileData;
      let filesList = this.fileList.map(item => item.file);
      for (let i = 0; i < filesList.length; i++) {
        // oss逻辑
        const imgFormat = filesList[i].name.split(".")[1];
        const imgName = filesList[i].name.split(".")[0];
        const imgMd5Name = this.random_string(10);
        let formData = new FormData();
        formData.append("OSSAccessKeyId", OSSAccessKeyId);
        formData.append("policy", policy);
        formData.append("signature", signature);
        formData.append("Filename", "${filename}");
        formData.append("key", `${that.catalogue}${imgMd5Name}.${imgFormat}`);
        formData.append("success_action_status", "200");
        formData.append("file", filesList[i]);

        $.ajax({
          url: "http://lshoot-images.oss-cn-shenzhen.aliyuncs.com",
          async: true,
          processData: false, // jQuery不要去处理发送的数据
          contentType: false, // jQuery不要去设置Content-Type请求头
          header: {
            "Content-Type": "multipart/form-data"
          },
          method: "post",
          data: formData,
          success: function(res) {
            that.imagesFeedback.push(
              `${that.catalogue}${imgMd5Name}.${imgFormat}`
            );
          },
          error: function(err) {
            that.imageUploadErrorNum++;
          }
        });
      }
    },
    // 图片上传 获取oss签名
    getOssAutograph() {
      let self = this;
      getOssAutograph().then(response => {
        const { code, data } = response;
        self.ossAjax = data.host;
        // self.catalogue = data.catalogue;
        self.fileData.key = self.catalogue + "${filename}";
        self.fileData.policy = data.policy;
        self.fileData.OSSAccessKeyId = data.accessKeyId;
        self.fileData.signature = data.signature;
      });
    },
    // 生成随机数
    random_string(len) {
      len = len || 32;
      var data = new Date();
      var str =
        data.getFullYear() +
        "" +
        (data.getMonth() + 1) +
        "" +
        data.getDate() +
        "" +
        data.getHours() +
        "" +
        data.getMinutes() +
        "" +
        data.getSeconds();
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return str + pwd;
    }
  },
  mounted: function() {
    $("#app").css("background", "#eef2f5");
    this.getQAHtml();
    this.getOssAutograph();
    getUser().then(response => {
      const { code, data } = response;
      this.userAvatar = response.headIcon;
    });
  },
  components: {
    hshead,
    "van-image": Image,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List,
    "van-icon": Icon,
    [Dialog.Component.name]: Dialog.Component
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";

.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
}

.help-kefu {
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  height: 2.5rem;
}

.help-kefu-img {
  width: 1.5rem;
  position: relative;
  top: 0.5rem;
  left: 0.7rem;
}

.help-kefu-span1 {
  font-size: 0.4rem;
  color: red;
  position: relative;
  top: -1.3rem;
  left: 2.5rem;
}
.help-kefu-span2 {
  font-size: 0.25rem;
  color: #969696;
  position: relative;
  top: -0.75rem;
  left: -0.1rem;
}

.help-feedback-img {
  width: 1rem;
  position: relative;
  top: 0.73rem;
  left: 1rem;
}

.help-feedback-span1 {
  font-size: 0.4rem;
  color: red;
  position: relative;
  top: -0.85rem;
  left: 2.5rem;
}
.help-feedback-span2 {
  font-size: 0.25rem;
  color: #969696;
  position: relative;
  top: -0.28rem;
  left: 0.67rem;
}

.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  .el-dialog {
    margin-bottom: 20px;
    transform: none;
    left: 0;
    position: relative;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    .el-dialog__header {
      position: fixed;
      background-color: #fff;
      width: 100%;
      z-index: 1;
      padding: 0.1rem;
      .el-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
      }
      .el-dialog__headerbtn {
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 0;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 16px;
      }
      .van-icon-close {
        position: fixed;
        top: 0.2rem;
        right: 0.2rem;
        color: #ff0000;
      }
    }
    .el-dialog__body {
      // padding: 30px 20px;
      color: #606266;
      font-size: 14px;
      #service {
        width: 100%;
        height: 100%;
        overflow: hidden;
        font-family: "微软雅黑";
      }
      #service .service-head {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        color: #333;
        background: #eee;
        position: fixed;
        left: 0;
        top: 0;
        font-size: 0.3rem;
        text-align: center;
        border-bottom: 0.02rem solid #ddd;
      }
      #service .service-head .back-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 0.8rem;
        height: 1rem;
        line-height: 1rem;
      }
      #service .service-head .back-img img {
        height: 0.5rem;
        vertical-align: top;
        margin-top: 0.25rem;
      }
      #service .service-head .close-btn {
        color: #ccc;
        height: 1rem;
        line-height: 1rem;
        right: 0.2rem;
        width: 1rem;
        position: absolute;
        top: 0;
        text-align: right;
        font-size: 0.6rem;
        cursor: pointer;
      }
      #service .service-content {
        background: #ececec;
        padding-bottom: 60px;
        margin-top: 55px;
        overflow: auto;
        overflow-x: hidden;
      }
      #service .service-content .service-content-out {
        padding-bottom: 0.5rem;
      }
      #service .service-content .service-content-out > div {
        display: inline-block;
      }
      #service .service-content .service-content-out .loadMore {
        width: 100%;
        text-align: center;
        padding-top: 0.5rem;
        text-decoration: underline;
        color: blue;
      }
      #service .service-content .loadMoreFinish {
        width: 100%;
        font-size: 0.24rem;
        text-align: center;
        margin-top: 0.3rem;
        color: #ccc;
        padding: 0 0 20px;
      }
      #service .service-content .service-time {
        width: 100%;
        font-size: 0.24rem;
        text-align: center;
        color: #ccc;
        margin-top: 0.3rem;
      }
      #service .service-content .left-content,
      #service .service-content .right-content {
        width: 7.2rem;
        padding: 0 0.15rem;
        margin-top: 0.2rem;
      }
      #service .service-content .left-content .this-icon,
      #service .service-content .right-content .this-icon {
        width: 0.8rem;
        height: 0.8rem;
        margin-left: 0.2rem;
        border-radius: 50%;
        overflow: hidden;
        float: left;
        background: #ccc;
      }
      #service .service-content .left-content .this-icon img,
      #service .service-content .right-content .this-icon img {
        width: 100%;
        vertical-align: top;
      }
      #service .service-content .left-content .left-content-p,
      #service .service-content .left-content .right-content-p,
      #service .service-content .right-content .left-content-p,
      #service .service-content .right-content .right-content-p {
        width: auto;
        max-width: 4.8rem;
        margin-left: 0.3rem;
        padding: 0.2rem;
        border-radius: 0.1rem;
        background: #94e96b;
        font-size: 0.28rem;
        margin-top: 0.1rem;
        line-height: 1.4;
        position: relative;
        word-wrap: break-word;
      }
      #service .service-content .left-content .left-content-p,
      #service .service-content .right-content .left-content-p {
        float: left;
        margin-left: 0.3rem;
        background: #fff;
      }
      #service .service-content .left-content .left-content-p::before,
      #service .service-content .right-content .left-content-p::before {
        content: "";
        // position: absolute;
        // width: 0;
        // height: 0;
        // left: -0.28rem;
        // border-width: 0.15rem;
        // border-style: solid;
        // border-color: transparent #fff transparent transparent;
      }
      #service .service-content .left-content .right-content-p,
      #service .service-content .right-content .right-content-p {
        float: right;
        margin-right: 0.3rem;
      }
      #service .service-content .left-content .right-content-p::after,
      #service .service-content .right-content .right-content-p::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        right: -0.28rem;
        top: 0.2rem;
        border-width: 0.15rem;
        border-style: solid;
        border-color: transparent transparent transparent #94e96b;
      }
      #service .service-content .right-content .this-icon {
        float: right;
        margin-right: 0.2rem;
      }
      #service .service-save {
        width: 100%;
        bottom: 0;
        background: #ededed;
        left: 0;
        padding: 0.2rem;
        border-top: 0.02rem solid #ddd;
        position: fixed;
      }
      #service .service-save .save-textarea {
        float: left;
        border: none;
        width: 5.1rem;
        background: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
      }
      #service .service-save .save-textarea textarea {
        resize: none;
        font-size: 0.28rem;
        line-height: 1.4;
        border: none;
        outline: 0;
        // padding: 0.2rem;
        width: 4.7rem;
        font-family: "微软雅黑";
      }
      #service .service-save .right-btn {
        float: left;
        width: 1.8rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background: #01ad59;
        color: #fff;
        text-align: center;
        font-size: 0.28rem;
        margin-left: 0.2rem;
        border-radius: 0.1rem;
        margin-top: 0.05rem;
      }
    }
  }
}

.kefu-qa {
  width: 90%;
  background-color: #fff;
  margin-top: 0.5rem;
  margin-left: 0.4rem;
  // height: 4.5rem;
  border-radius: 20px 20px 0px 0px;
}

.kefu-qa-issue {
  position: relative;
  // top: 0.2rem;
}

.kefu-qa-guess {
  background-color: #383838;
  border-radius: 20px 20px 0px 0px;
  height: 2rem;
  color: #fff;
  font-size: 0.5rem;
}
.kefu-qa-guess-span1 {
  position: relative;
  top: 0.3rem;
  left: 1.8rem;
}
.kefu-qa-guess-span2 {
  position: relative;
  top: 1rem;
  left: -0.87rem;
  font-size: 0.3rem;
}
.kefu-qa-ul li {
  padding: 0.14rem;
  border-bottom: 1px #eee solid;
}

.kefu-qa-more {
  color: #feffb6;
  position: relative;
  top: 1rem;
  left: 6rem;
  font-size: 0.25rem;
}
</style>


// WEBPACK FOOTER //
// src/views/user/helpFeedback.vue